import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Grid, Row, Col, Button } from 'react-bootstrap';
import { Link } from 'react-scroll';
import { translate } from 'react-i18next';

import LanguageSelector from '../LanguageSelector';
import { scrollDelay, scrollDuration, scrollOffset } from '../../util/constants';
import IdentificationForm from '../../containers/IdentificationForm';

import AppIcon from '../AppIcon';
import InnerHtmlContent from '../InnerHtmlContent';
import BankSelection from '../BankSelection/index';

class MainLogin extends Component {

  constructor(props) {
    super(props);
    this.onManagementClicked = this.onManagementClicked.bind(this);
    this.onPathClicked = this.onPathClicked.bind(this);
    this.onBackButtonClicked = this.onBackButtonClicked.bind(this);
    this.onLoginClicked = this.onLoginClicked.bind(this);
    this.state = {
      bankLoginShow: false
    };
  }

  onManagementClicked() {
    const { managementSelected, setManagementOptionWithSinglePath, triggerInitialScroll } = this.props;
    if (managementSelected) {
      triggerInitialScroll(false);
      return;
    }
    setManagementOptionWithSinglePath();
  }

  onPathClicked() {
    this.props.triggerInitialScroll(true);
  }

  onBackButtonClicked() {
    this.setState({
      bankLoginShow: false
    });
  }

  onLoginClicked() {
    this.setState({
      bankLoginShow: true
    });
  }

  render() {
    const {
      showLoginForm,
      uniquePath,
      languages,
      userIdentified,
      fetchPathAfterLogin,
      viaSso,
      loginPolicyType,
      t
    } = this.props;
    const hideArrow = !userIdentified && fetchPathAfterLogin;
    const rightColumnContent = showLoginForm ? (
      <div>
        <div className="box-header">
          <h1 tabIndex={0} id={'intro-box-left-header'}>{t('login.title')}</h1>
        </div>
        {loginPolicyType === 'STRONG' &&
        <Button className="action-btn center-block login-button" onClick={this.onLoginClicked}>
          {t('identification:identificationForm.submitButtonText')}
        </Button>
        }
        { loginPolicyType !== 'STRONG' && <IdentificationForm /> }
      </div>
    ) : (
      <div>
        <Button
          onClick={this.onPathClicked}
          className="basic-action start-reservation-link center-block"
        >
          {t('booking:continueReservationButton')}
        </Button>
      </div>
    );
    const rightColumnWrapper = (
      <div>
        { rightColumnContent }
        { uniquePath &&
        <Button
          onClick={this.onManagementClicked}
          bsStyle="link"
          className="basic-action-link start-cancel-reservation-link center-block"
        >
          {viaSso || loginPolicyType === 'STRONG' ? t('booking:sectionTitles.history') : t('booking:cancelReservation.startCancelling')}
        </Button>
        }
      </div>
    );
    return (
      <div>
        <div className="main-login-top">
          <Grid fluid className="intro-box intro-box-left">
            {this.state.bankLoginShow && <BankSelection onBackButtonClicked={this.onBackButtonClicked} /> }
            {!this.state.bankLoginShow &&
            <Row>
              <Col className="intro-box-left" xs={12} sm={12} md={7} lg={7}>
                <div>
                  <div className="box-header">
                    <h1>{t('login.title')}</h1>
                    <p>
                      <InnerHtmlContent content={t('login.info')} />
                    </p>
                    <p>
                      <InnerHtmlContent content={t('login.info2')} />
                    </p>
                    {uniquePath &&
                    <LanguageSelector
                      languages={languages}
                    />
                    }
                  </div>
                </div>
              </Col>
              <Col className="intro-box-right" xs={12} sm={12} md={5} lg={5}>
                {rightColumnWrapper}
              </Col>
            </Row>
            }
          </Grid>
          { !hideArrow &&
          <Link
            className="arrow-down"
            to="booking-phase-symptoms"
            duration={scrollDuration}
            delay={scrollDelay}
            offset={scrollOffset}
            smooth
          >
            <AppIcon iconName="ARROW_DOWN" />
          </Link>
          }
        </div>
      </div>
    );
  }
}

MainLogin.propTypes = {
  triggerInitialScroll: PropTypes.func.isRequired,
  showLoginForm: PropTypes.bool.isRequired,
  userIdentified: PropTypes.bool.isRequired,
  setManagementOptionWithSinglePath: PropTypes.func.isRequired,
  managementSelected: PropTypes.bool,
  viaSso: PropTypes.bool.isRequired,
  uniquePath: PropTypes.bool.isRequired,
  languages: PropTypes.array.isRequired,
  fetchPathAfterLogin: PropTypes.bool.isRequired,
  loginPolicyType: PropTypes.string,
  t: PropTypes.func.isRequired
};

MainLogin.defaultProps = {
  uniquePath: false,
  managementSelected: false,
  loginPolicyType: 'ONLY_SSN'
};

export default translate(['common', 'booking'], { wait: true })(MainLogin);



// WEBPACK FOOTER //
// ./src/components/MainLogin/MainLogin.jsx